export class ReservationError extends Error {
  conflict?: boolean;
  leadIds?: (string | number)[];

  constructor(
    message?: string,
    conflict?: boolean,
    leadIds?: (string | number)[],
  ) {
    super(message);
    this.name = 'ReservationError';
    this.conflict = conflict;
    this.leadIds = leadIds;
    Object.setPrototypeOf(this, ReservationError.prototype);
  }
}
